export enum CallFlowType {
  BASIC = "BASIC",
  ADVANCED = "ADVANCED",
}
